export default function SectionHeading({ eyebrow, title, lede, align = "left" }) {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignment}`}>
      {eyebrow && (
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-[#E8772E]">
          {eyebrow}
        </p>
      )}
      <h2 className="font-serif-display text-3xl font-medium leading-tight text-[#0A1128] sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {lede && (
        <p className="mt-5 text-base leading-relaxed text-[#475569] sm:text-lg">
          {lede}
        </p>
      )}
    </div>
  );
}
